export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/Home.vue'),
    meta: {
      requiresAuth: true,
      title: 'Главная',
      layout: 'default'
    }
  },
  {
    path: '/demo/custom-script',
    name: 'demo-custom-script',
    component: () => import('@/pages/DemoCustomScript.vue'),
    meta: {
      requiresAuth: true,
      title: 'Демо executeCustomScript',
      layout: 'default'
    }
  }
]
